import React, { memo, useState } from 'react';
import './TicketList.css';

const TicketList = memo(({ tickets }) => {
  const [filter, setFilter] = useState('all');
  const [copiedId, setCopiedId] = useState(null);
  
  const filteredTickets = tickets.filter(ticket => {
    if (filter === 'all') return true;
    if (filter === 'open') return ticket.status !== 'Resolved';
    if (filter === 'closed') return ticket.status === 'Resolved';
    return true;
  });
  
  const copyToClipboard = (ticketId) => {
    navigator.clipboard.writeText(ticketId).then(() => {
      setCopiedId(ticketId);
      setTimeout(() => setCopiedId(null), 2000);
    });
  };
  
  return (
    <div className="ticket-list-container">
      <div className="ticket-filter">
        <button 
          className={`filter-btn ${filter === 'all' ? 'active' : ''}`}
          onClick={() => setFilter('all')}
        >
          All ({tickets.length})
        </button>
        <button 
          className={`filter-btn ${filter === 'open' ? 'active' : ''}`}
          onClick={() => setFilter('open')}
        >
          Open ({tickets.filter(t => t.status !== 'Resolved').length})
        </button>
        <button 
          className={`filter-btn ${filter === 'closed' ? 'active' : ''}`}
          onClick={() => setFilter('closed')}
        >
          Closed ({tickets.filter(t => t.status === 'Resolved').length})
        </button>
      </div>
      <div className="ticket-list">
        {filteredTickets.map((ticket, index) => (
          <div key={index} className={`ticket-item ${ticket.priority}`}>
            <div className="ticket-header">
              <button 
                className={`ticket-id-btn ${copiedId === ticket.id ? 'copied' : ''}`}
                onClick={() => copyToClipboard(ticket.id)}
                title="Click to copy ticket ID"
              >
                {copiedId === ticket.id ? '✓ Copied!' : ticket.id}
              </button>
              <span className={`ticket-priority priority-${ticket.priority}`}>
                {ticket.priority.toUpperCase()}
              </span>
            </div>
            <div className="ticket-details">
              {ticket.title} • {ticket.status} • {ticket.days} days
            </div>
          </div>
        ))}
      </div>
    </div>
  );
});

TicketList.displayName = 'TicketList';

export default TicketList;